import { Rule } from 'rc-field-form/lib/interface';

export const email: Rule[] = [
  {
    required: true,
    message: 'O e-mail é obrigatório',
  },
  {
    type: 'email',
    message: 'O e-mail informado não é válido',
  },
];

export const password = [
  {
    required: true,
    message: 'A senha é obrigatória',
  },
];

export const newPassword = [
  {
    required: true,
    message: 'A nova senha é obrigatória',
  },
];

export const passwordConfirm: Rule[] = [
  {
    required: true,
    message: 'A confirmação de senha é obrigatória',
  },
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('password') !== value) {
        return Promise.reject(new Error('As duas senhas não coincidem'));
      }
      return Promise.resolve();
    },
  }),
];
